import React from "react";
import { Helmet } from "react-helmet-async";

export default function SeoMeta({ title, description, url, image, twitterDescription }) {
    const twitterDesc = twitterDescription ?? description;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={twitterDesc} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
}
